
















import { Prop, Component, Vue } from "vue-property-decorator";

@Component({})
export default class AppHeaderProfile extends Vue {
  @Prop({ default: "" }) icon!: string;
  @Prop({ default: "" }) name!: string;
  @Prop({ default: "" }) serviceName!: string;
}
